import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { APP_OPTIONS } from '../../../config/constants';

import Button from '../../Button';

import './style.scss';

export interface SearchOcularDBCTAProps {
  className?: string;
}

const SearchOcularDBCTA: React.FC<SearchOcularDBCTAProps> = (props) => {
  const { className } = props;

  const { t } = useTranslation();

  const classNames = c('SearchOcularDB__CTA', className);


  return (
    <div className={classNames}>
      <h3 className="SearchOcularDB__CTA__title">{t('components.search_oculardb.cta.title')}</h3>
      <a href={APP_OPTIONS.parameters.ocularDBCtaLink}>
        <Button
          type="primary"
          className="SearchOcularDB__CTA__button button"
        >
          {t('components.search_oculardb.cta.action')}
        </Button>
      </a>
    </div>
  );
};

export default SearchOcularDBCTA;
